import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios'
import Konami from 'konami'
import msal from 'vue-msal'

new Konami(function() {
  let value=localStorage.getItem('brandingOverride') ? localStorage.getItem('brandingOverride') : "0"
  localStorage.setItem('brandingOverride', value=="0" ? "1" : "0")
  window.location.reload()
});
let router=null
if(process.env.VUE_APP_CUSTOM_ROUTER){
  router=require('./config/router/'+process.env.VUE_APP_CUSTOM_ROUTER).default
} else {
  router=require('./router').default
}

function getUrlParams(search) {
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split('=')
    return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}

if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
  let onTokenFunc = function (ctx, error, response) {
    axios.interceptors.request.use(function (config) {
      if (error == null) {
        config.headers.Authorization = "Bearer " + ctx.data.accessToken;
      }
      return config;
    }, function (error) {
      return Promise.reject(error);
    });
  }
  Vue.use(msal, {
    auth: {
      clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
      authority: process.env.VUE_APP_MSAL_AUTHORITY,
      redirectUri: process.env.VUE_APP_LOGIN_REDIRECT_URL,
      onToken: onTokenFunc,
      navigateToLoginRequestUrl: true
    },
    request: {
      scopes: [process.env.VUE_APP_MSAL_SCOPE]
    },
    cache: {
      cacheLocation: 'localStorage',
    }
  });

} else {
  let queryParams=getUrlParams(location.search)
  if(queryParams.token&&queryParams.token!=""){
    localStorage.setItem('pass', queryParams.token)
    history.replaceState && history.replaceState(
        null, '', location.pathname + location.search.replace(/[\?&]token=[^&]+/, '').replace(/^&/, '?') + location.hash
    )
  }
  axios.interceptors.request.use(function (config) {
    if (process.env.VUE_APP_LOGIN=='yes') {
      let pass = localStorage.getItem('pass');
      if (pass && pass !== '') {
        config.headers.Authorization = "Bearer " + pass;
      } else if (process.env.VUE_APP_OVERRIDE_TOKEN){
        config.headers.Authorization = "Bearer " + process.env.VUE_APP_OVERRIDE_TOKEN;
      }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
}


axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (process.env.VUE_APP_LOGIN=='yes'&&error.response&&401 === error.response.status) {
    if(localStorage.getItem('pass')){
      localStorage.setItem('pass', null)
    }
    if(router.currentRoute.name!=="login") {
      router.push({
        name: 'login',
        query: {
          wantedRoute: router.currentRoute.fullPath
        },
      });
    }
  } else if (error.response&&403 === error.response.status) {
    store.dispatch('callSnackbar', {text: 'Error : This account is not allowed to access this resource'})
  } else {
    return Promise.reject(error);
  }
})

Vue.config.productionTip = false


import VuetifyDaterangePicker from "vuetify-daterange-picker"
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css"
Vue.use(VuetifyDaterangePicker)

import { abilitiesPlugin } from '@casl/vue'
import {ability} from './store/ability'
Vue.use(abilitiesPlugin, ability)

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor)

import heatmapjsVue from 'heatmapjs-vue'
Vue.use(heatmapjsVue)

if(process.env.VUE_APP_INTERFACE_TRANSLATION){
  let translator = require('./translator.js').default
  translator.setup()
  Vue.filter('translate', function (value) {
    return translator.translate(value)
  })
} else {
  Vue.filter('translate', function (value) {
    return value
  })
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



